import {
  formatToIndianRupee,
  ParseTableDate,
  ParseTableLabelDate,
} from 'app/utils/Parsers';
import {
  GAME_TYPE_LABELS,
  TRIGGER_TYPE_LABELS,
} from 'app/constants/campaign-constants';

export const TableHeaderConstant = {
  Name: 'Name',
  MallName: 'Mall Name',
  Email: 'Email',
  Location: 'Location',
  isCDIT: 'isCDIT',
  ContactNumber: 'Contact No.',
  Timing: 'Timing',
  ContactPerson: 'Contact Person',
  Phone: 'Phone',
  StartDate: 'Start Date',
  EndDate: 'End Date',
  StartTime: 'Start Time',
  EndTime: 'End Time',
  RegistrationId: 'Registration Id', // Corrected from RegisterationId
  City: 'City',
  Headline: 'Headline', // Corrected from Heaing
  Description: 'Description',
  PublishedBy: 'Published by',
  Ranking: 'Ranking',
  Image: 'Image',
  StoreName: 'Store Name',
  Status: 'Status',
  Action: 'Actions',
  EditAction: 'Edit Action',
  Address: 'Address',
  ServiceName: 'Service Name',
  StoreType: 'Store Type',
  RangeStart: 'Range Start',
  RangeEnd: 'Range End',
  Discount: 'Discount',
  VoucherTitle: 'Voucher Title',
  LoyaltyPoints: 'Loyalty Points',

  // Dynamic keys for accessors
  LoyaltyPointsKey: 'loyaltyPoints',
  TitleKey: 'title',
  // Must match the backend response key exactly (CustomerService.ts,
  // customerVoucherExportRow.ts) — lower-case first letter.
  ComplimentaryKey: 'complimentary',
  VoucherTitleKey: 'voucherTitle',
  DiscountKey: 'discount',
  Range: 'Min range-Max range (Rs)',
  RangeKey: 'range',
  NameKey: 'name',
  StoreNameKey: 'storeName',
  MallNameKey: 'mallName',
  ServiceNameKey: 'serviceName',
  EmailKey: 'email',
  LocationKey: 'location',
  LocationDetailsKey: 'locationDetails',
  ContactNumberKey: 'contact_number',
  ContactNumberKey2: 'contactNumber',
  ContactNumberKey3: 'phoneNumber',
  TimingKey: 'timing',
  ContactPersonKey: 'contactPersonName',
  PhoneKey: 'phone',
  StartDateKey: 'startDate',
  EndDateKey: 'endDate',
  StartTimeKey: 'startTime',
  EndTimeKey: 'endTime',
  RegistrationIdKey: 'registrationId',
  CityKey: 'city',
  HeadlineKey: 'headline',
  DescriptionKey: 'description',
  PublishedByKey: 'publishedBy',
  RankingKey: 'ranking',
  AddressKey: 'address',
  ImageKey: '',
  StatusKey: '',
  ActionKey: '',
  TypeKey: '',
  Title: 'Title',
  Complimentary: 'Complimentary',
  Parent: 'Parent',
  ParentKey: 'parentName',
  DayofWeek: 'Day of Week',
  DayofWeekKey: 'dayOfWeek',

  BillDate: 'Bill Date',
  BillDateKey: 'invoice_date',
  BillNumber: 'Bill No',
  BillNumberKey: 'invoice_number',
  BillAmount: 'Bill Amount (Rs)',
  BillAmountKey: 'shopping_amount',
  CategoryName: 'Category Name',
  CategoryNameKey: 'category_name',
  BrandName: 'Brand Name',
  BrandNameKey: 'storeName',
  BillStatus: 'Bill Status',
  BillStatusKey: '',
  ViewDetails: 'View Details',
  ViewDetailsKey: '',

  RegistrationDateKey: 'registrationDate',
  LastActiveAtKey: 'lastActiveAt',
  ReserveVoucherKey: 'reserveVoucher',
  CollectedVoucherKey: 'collectedVoucher',
  TotalPointsKey: 'totalPoints',
  TotalShoppingAmountKey: 'totalShoppingAmount',
  ExpiringPointsKey: 'expiringPoints',
  UsedPointsKey: 'usedPoints',
  TierNameKey: 'tierName',
  CustomerStatusKey: '',
  RegistrationDate: 'Registration Date',
  LastActiveAt: 'Last Active Date',
  ReserveVoucher: 'Vouchers Reserved',
  CollectedVoucher: 'Vouchers Collected',
  TotalPoints: 'Total Points',
  TotalShoppingAmount: 'Total Shopping Amount',
  Last12MonthSpend: 'Last 12-Month Spend',
  Last12MonthSpendKey: 'last12MonthSpend',
  ExpiringPoints: 'Expiring Points',
  CumulativeUsablePoints: 'Cumulative Usable Points',
  CumulativeUsablePointsKey: 'cumulativeUsablePoints',
  UsedPoints: 'Used Points',
  TierName: 'Tier Status',
  CustomerStatus: 'Customer Status',
  BillUploadDate: 'Bill Upload',
  BillUploadDateKey: 'billUpload',
  CustomerBillAmount: 'Bill Amount',
  CustomerBillAmountKey: 'billAmount',
  NewPointsAdded: 'Points Added',
  NewPointsAddedKey: 'newPointsAdded',
  CollectionCode: 'Voucher Collection Code',
  CollectionCodeKey: 'collectionCode',
  VoucherStatus: 'Voucher Status',
  VoucherStatusKey: '',
  CollectVoucher: 'Collect Voucher',
  CollectVoucherKey: '',
  PointsAdded: 'Points Added',
  PointsAddedKey: 'pointsAdded',
  ShoppingAmount: 'Total Shopping Amount',
  ShoppingAmountKey: 'shoppingAmount',
  MigratedShopping: 'Migrated Shopping Amount',
  MigratedShoppingKey: 'migratedShopping',
  QualifyingSpend: 'Past 12-Month Spend',
  QualifyingSpendKey: 'qualifyingSpend',
  TierEarnedBy: 'Tier change amount',
  TierEarnedByKey: 'qualifiedAmount',
  UpgradedOn: 'Upgraded On',
  UpgradedOnKey: 'upgradedOn',
  DowngradeDue: 'Downgrade Due',
  DowngradeDueKey: 'downgradeDue',
  Upload_date: 'Upload Date',
  upload_dateKey: 'upload_date',
  Gender: 'Gender',
  GenderKey: 'gender',
  Approver: 'Approver',
  ApproverKey: 'billApprovedByDealer',
  FirstBillDate: 'First Bill Upload Date',
  firstBillDateKey: 'firstBillUploadDate',
  DateOfDownload: 'Download Date',
  DateOfDownloadKey: 'dateofDownload',
  LastLogin: 'Last Login',
  LastLoginKey: 'lastLogin',
  RegistrationDateFixed: 'RegistrationDateFixed',
  RegistrationDateFixedKey: 'registrationDateFixed',
  ReferrerContact: 'ReferrerContact',
  ReferrerContactKey: 'referrerContact',
  ReferrerName: 'ReferrerName',
  ReferrerNameKey: 'referrerName',
  Anniversay: 'Anniversary',
  AnniversaryKey: 'anniversary',
  Dob: 'Dob',
  DobKey: 'dob',
  Id: 'Id',
  IdKey: 'id',
  Source: 'Source',
  SourceKey: 'source',
  Balance: 'Balance',
  BalanceKey: 'balance',
  Coins: 'Coins',
  CoinsKey: 'coins',
  LedgerType: 'Type',
  LedgerTypekey: 'type',
  ExpiryDate: 'Expiry Date',
  ExpiryDateKey: 'expiryDate',
  Type: 'Type',

  PrivilegeBenefits: 'Privilege Benefits',
  PrivilegeBenefitsKey: 'benefits',

  PrivilegeDates: 'Privilege Date',
  PrivilegeDatesKey: '',

  PrivilegeUsed: 'Privilege Used',
  PrivilegeUsedKey: 'collectedCount',

  PrivilegeCount: 'Privilege Count',
  PrivilegeCountKey: 'totalCount',

  CollectPrivilege: 'Collect Privilege',
  CollectPrivilegeKey: '',
  TotalAcceptedBills: 'Total Accepted Bills',
  TotalAcceptedBillsKey: 'totalAcceptedBills',
  MembershipType: 'Membership Type',
  MembershipTypeKey: 'membershipType',
  ParentMallPoints: 'Parent Mall Points',
  ParentMallPointsKey: 'parentMallPoints',
  TotalExpiredPoints: 'Total Expired Points',
  TotalExpiredPointsKey: 'totalExpiredPoints',
  TotalPointsLeft: 'Total Points Left',
  TotalPointsLeftKey: 'totalPointsLeft',
  TotalUsedPoints: 'Total Used Points',
  TotalUsedPointsKey: 'totalUsedPoints',
  Anniversary: 'Anniversary',

  PublishedStatus: 'Published Status',
  PublishedStatusKey: '',

  PrivilegeTaken: 'Privileges Taken',
  PrivilegeTakenKey: 'priviligeCount',

  ParentMall: 'Parent Mall',
  ParentMallKey: 'parentMall',
  parentMallKey2: 'parent_mall',

  Tier_Name: 'Tier Name',

  Date_Time: 'Date Time',
  Date_TimeKey: 'dateTime',
  ExpiredDate: 'Expiry Date',
  ExpiredDateKey: 'expiredDate',

  DaysVisibleOnHomeScreen: 'Days Visible on Home Screen',
  DaysVisibleOnHomeScreenKey: 'daysVisibleOnHomeScreen',
  Priority: 'Priority',
  PriorityKey: 'priority',

  VoucherCollectedDate: 'Voucher collected date',
  VoucherCollectionDateKey: 'collectDate',
  VoucherReserveDate: 'Voucher Reserve Date',
  VoucherReserveDateKey: 'reserveDate',

  VoucherReservedCount: 'Reserved Count',
  VoucherClaimedCount: 'Claimed Count',

  TotalAvailableVouchers: 'Total Vouchers',
  TotalAvailableVouchersKey: 'voucherCount',
  
  VoucherReservedCountKey: 'reservedVoucherCount',
  VoucherClaimedCountKey: 'claimedVoucherCount',

  MallWiseBillTotal: 'Mall Wise Bill Total',
  MallWiseBillTotalKey: 'mallWiseBillSum',

  EachBillRewards: 'Each Bill Rewards',
  EachBillRewardsKey: 'billEachPoint',

  ReserveVoucherHeader: 'Reserve Voucher',
  CancelVoucherHeader: 'Cancel Voucher',

  ReservedDate: 'Reserved Date',
  CreatedAtKey: 'createdAt',

  CancelDate: 'Cancel Date',
  UpdatedAtKey: 'canceledAt',

  VoucherSerialNumber: 'Voucher Serial Number',
  VoucherSerialNumberKey: 'voucherSerialNumber',
  BrandNameKey2: 'brandName', 

  IsDeletedStatus: 'Restore',
  IsdeletedStatusKey: '',

  Denomination: 'Loyalty Point',

  TotalMember: 'Total Member', // Label
  TotalMemberKey: 'totalMember', // Key

  TotalExpiringPoints: 'Points expiring (last date of the month)', // Label
  TotalExpiringPointsKey: 'totalExpiringPoints', // Key

  VoucherCustomerCount:
    'Last 3 Month voucher collected or bill uploaded (Active Members) Total Member', // Label
  VoucherCustomerCountKey: 'voucherCustomerCount', // Key

  TotalBillCoins:
    'Last 3 Month   bill upload (Active Members)Points Liability usable points', // Label
  TotalBillCoinsKey: 'totalBillCoins', // Key

  InactiveCustomerCount:
    'Passive Member (Non active since past three months)Total Member', // Label
  InactiveCustomerCountKey: 'inactiveCustomerCount', // Key

  ActiveMemberPercentage: 'Active Member Percentage', // Label
  ActiveMemberPercentageKey: 'activeMemberPercentage', // Key

  NonActiveMemberPercentage: 'Non-Active Member Percentage', // Label
  NonActiveMemberPercentageKey: 'nonActiveMemberPercentage', // Key

  TotalVouchers: 'Total Vouchers', // Label
  TotalVouchersKey: 'totalVouchers', // Key

  TotalReservedVouchers: 'Total Reserved Vouchers', // Label
  TotalReservedVouchersKey: 'totalReservedVouchers', // Key

  IssuedVouchersValue: 'Value of Issued Vouchers', // Label
  IssuedVouchersValueKey: 'issuedVouchersValue', // Key

  BrandDenomUID: 'Brand Denomination UID', // Label
  BrandDenomUIDKey: 'brand_denom_uid', // Key

  PendingVoucher: 'Total pending Voucher', // Label
  PendingVoucherKey: 'pendingVoucher', // Key,

  DenominationKey: 'denomination',

  UsablePoints: 'Points (Usable Points)', // label
  UsablePointsKey: 'totalUsablePoints', // key

  VoucherCollectedPoints:
    'Last 3 Month  voucher collected (Active Members) Points Liability usable', //label
  VoucherCollectedPointsKey: 'voucherCollectedPoints', //key

  TotalCustomerBillCount:
    'Last 3 Month  bill upload (Active Members) Total Member',
  TotalCustomerBillCountKey: 'totalCustomerBillCount',

  BrandVoucherListed: 'Brand voucher listed',
  BrandVoucherListedKey: 'brandName',

  BrandVoucherListedDenomination: 'Brand voucher listed denomination',
  BrandVoucherListedDenominationKey: 'denomination',

  ListedVoucherTotal: 'listed voucher total',
  ListedVoucherTotalKey: 'totalVouchers',

  IssuedQuantity: 'Issued Quantity',
  IssuedQuantityKey: 'totalReservedVouchers',

  VoucherQtyReceivedByBrand: 'Voucher Qty received by brand',
  voucherQtyReceivedByBrandKey: 'voucher_qty',

  GVAmtReceivedByBrand: 'GV Amt received by brand',
  GVAmtReceivedByBrandKey: 'gv_amt',

  Consumption: 'Consumption',
  ConsumptionKey: 'consumption',

  IncrementAmount: 'Increment Amount',
  IncrementAmountKey: 'increment_amount',

  IncrementPercent: 'Increment %',
  IncrementPercentKey: 'increment_percentage',

  Remarks: 'Remarks',
  RemarksKey: 'remarks',

  InputAction: 'InputAction',
  Calculate: 'calculate',

  AccrualCount: 'Accrual Count',
  AccrualCountKey: 'accrualCount',
  AccrualAmount: 'Accrual Amount',
  AccrualAmountKey: 'accrualAmount',
  EnthusiastCount: 'Enthusiast Count',
  EnthusiastCountKey: 'enthusiastCount',
  EnthusiastAmount: 'Enthusiast Amount',
  EnthusiastAmountKey: 'enthusiastAmount',
  InsiderCount: 'Insider Count',
  InsiderCountKey: 'insiderCount',
  InsiderAmount: 'Insider Amount',
  InsiderAmountKey: 'insiderAmount',
  InfluencerCount: 'Influencer Count',
  InfluencerCountKey: 'influencerCount',
  InfluencerAmount: 'Influencer Amount',
  InfluencerAmountKey: 'influencerAmount',
  Customername:"Customer Name",
  CustomernameKey:"customerName",
  RemainingVouchers:"Remaining Vouchers",
  RemainingVouchersKey:"remainingVouchers",

  VoucherIssuedBy:"Voucher Issued By",
  VoucherIssuedByKey:"issuedByDetail",
 
  ComplementaryVoucherDenomination: 'Complementary Voucher Denomination',
  ComplementaryVoucherDenominationKey: 'complementryVoucherDenomination',

  ComplementaryVoucher: 'Complementary Voucher',
  ComplementaryVoucherKey: 'complementryVoucher',

  // Gamification columns on the voucher-claimed report. Start/End Date are the
  // campaign's BILL-date window, not the voucher's own validity dates — hence
  // the deliberately plain labels the client asked for.
  GamePlayed: 'Game Played',
  GamePlayedKey: 'gamePlayed',
  GameBillStartDate: 'Start Date',
  GameBillStartDateKey: 'billStartDate',
  GameBillEndDate: 'End Date',
  GameBillEndDateKey: 'billEndDate',

};
export const BannerHeader = [
  {
    Header: TableHeaderConstant.Ranking,
    accessor: '',
  },
  {
    Header: TableHeaderConstant.Image,
    accessor: '',
  },
  {
    Header: TableHeaderConstant.Type,
    accessor: '',
  },
  {
    Header: TableHeaderConstant.Status,
    accessor: '',
  },
  {
    // BL-10/D-13: total recorded visits for this banner, attached by
    // MallListService.fetchData. 0 (never blank) when a banner has none.
    Header: 'Clicks',
    accessor: 'clickCount',
    Cell: ({ value }) => value ?? 0,
  },
  {
    Header: TableHeaderConstant.Action,
    accessor: '',
  },
];
export const userHeader = [
  { Header: TableHeaderConstant.Name, accessor: TableHeaderConstant.NameKey },
  {
    Header: TableHeaderConstant.ContactNumber,
    accessor: TableHeaderConstant.PhoneKey,
  },
  {
    Header: TableHeaderConstant.Email,
    accessor: TableHeaderConstant.EmailKey,
  },
  {
    Header: TableHeaderConstant.Status,
    accessor: TableHeaderConstant.StatusKey,
  },
  {
    Header: TableHeaderConstant.Action,
    accessor: TableHeaderConstant.ActionKey,
  },
];
export const storeTableHeader = [
  {
    Header: TableHeaderConstant.Name,
    accessor: TableHeaderConstant.StoreNameKey,
  },
  {
    Header: TableHeaderConstant.MallName,
    accessor: TableHeaderConstant.MallNameKey,
  },
  {
    Header: TableHeaderConstant.Location,
    accessor: TableHeaderConstant.LocationKey,
  },
  {
    Header: TableHeaderConstant.ContactNumber,
    accessor: TableHeaderConstant.ContactNumberKey2,
  },

  {
    Header: TableHeaderConstant.Timing,
    accessor: TableHeaderConstant.TimingKey,
  },
  {
    Header: TableHeaderConstant.StoreType,
    accessor: '',
  },
  { Header: TableHeaderConstant.Status, accessor: '' },
  { Header: TableHeaderConstant.isCDIT, accessor: 'isCdit', id: 'isCdit', Cell: ({ value }) => (value ? 'Yes' : 'No') },
  { Header: TableHeaderConstant.Action, accessor: '' },
];
export const supportServiceTableHeader = [
  {
    Header: TableHeaderConstant.ServiceName,
    accessor: TableHeaderConstant.ServiceNameKey,
  },
  {
    Header: TableHeaderConstant.MallName,
    accessor: TableHeaderConstant.MallNameKey,
  },
  {
    Header: TableHeaderConstant.ContactPerson,
    accessor: TableHeaderConstant.ContactPersonKey,
  },
  {
    Header: TableHeaderConstant.ContactNumber,
    accessor: TableHeaderConstant.ContactNumberKey2,
  },
  { Header: TableHeaderConstant.Status, accessor: '' },
  { Header: TableHeaderConstant.Action, accessor: '' },
];

export const mallTableHeader = (userType) => {
  const headers = [
    { Header: TableHeaderConstant.Name, accessor: TableHeaderConstant.NameKey },
    { Header: TableHeaderConstant.City, accessor: TableHeaderConstant.CityKey },
    {
      Header: TableHeaderConstant.Address,
      accessor: TableHeaderConstant.AddressKey,
    },
    {
      Header: TableHeaderConstant.ContactNumber,
      accessor: TableHeaderConstant.ContactNumberKey,
    },
    {
      Header: TableHeaderConstant.Timing,
      accessor: TableHeaderConstant.TimingKey,
    },
    {
      Header: TableHeaderConstant.Status,
      accessor: TableHeaderConstant.StatusKey,
    },
    {
      Header: TableHeaderConstant.PublishedStatus,
      accessor: TableHeaderConstant.PublishedStatusKey,
    },
  ];

  if (userType === 'su') {
    headers.push({
      Header: TableHeaderConstant.Action,
      accessor: TableHeaderConstant.ActionKey,
    });
  }

  return headers;
};

export const customerHeader = [
  {
    Header: TableHeaderConstant.ContactNumber,
    accessor: TableHeaderConstant.PhoneKey,
  },
  { Header: TableHeaderConstant.Name, accessor: TableHeaderConstant.NameKey },
  { Header: TableHeaderConstant.Email, accessor: TableHeaderConstant.EmailKey },
  {
    Header: TableHeaderConstant.RegistrationId,
    accessor: TableHeaderConstant.RegistrationIdKey,
  },
  { Header: 'Last Active date', accessor: 'lastActiveDate' },
  { Header: 'Voucher Reserved', accessor: 'voucherReserved' },
  { Header: TableHeaderConstant.Status, accessor: '' },
  { Header: TableHeaderConstant.Action, accessor: '' },
];

export const eventHeader = [
  { Header: TableHeaderConstant.Name, accessor: TableHeaderConstant.NameKey },

  {
    Header: TableHeaderConstant.MallName,
    accessor: TableHeaderConstant.MallNameKey,
  },
  // {
  //   Header: TableHeaderConstant.Headline,
  //   accessor: TableHeaderConstant.HeadlineKey,
  // },
  {
    Header: TableHeaderConstant.ContactNumber,
    accessor: TableHeaderConstant.PhoneKey,
  },
  {
    Header: TableHeaderConstant.Location,
    accessor: TableHeaderConstant.LocationDetailsKey,
  },
  {
    Header: TableHeaderConstant.StartDate,
    accessor: TableHeaderConstant.StartDateKey,
    Cell: ({ value }) => {
      return ParseTableLabelDate(value);
    },
  },
  {
    Header: TableHeaderConstant.EndDate,
    accessor: TableHeaderConstant.EndDateKey,
    Cell: ({ value }) => {
      return ParseTableLabelDate(value);
    },
  },
  {
    Header: TableHeaderConstant.Timing,
    accessor: TableHeaderConstant.TimingKey,
  },
  {
    Header: TableHeaderConstant.Status,
    accessor: TableHeaderConstant.StatusKey,
  },
  {
    Header: TableHeaderConstant.Action,
    accessor: TableHeaderConstant.ActionKey,
  },
];
export const gameHeader = [
  { Header: TableHeaderConstant.Name, accessor: 'title' },
  { Header: 'Slug', accessor: 'slug' },
  { Header: 'Sort Order', accessor: 'sortOrder' },
  { Header: TableHeaderConstant.Status, accessor: TableHeaderConstant.StatusKey },
  {
    // Cross-check against the CDN games-manifest: a registered game whose
    // files were removed from the deployed bundle shows "Missing on CDN"
    // (an Active game in that state renders a broken WebView in the app —
    // toggle it OFF). null/unknown (manifest unreachable) renders a dash.
    Header: 'CDN',
    accessor: 'onCdn',
    id: 'onCdn',
    Cell: ({ value }) =>
      value === false ? (
        <span className='inactive bdg'>Missing on CDN</span>
      ) : value === true ? (
        <span className='active bdg'>OK</span>
      ) : (
        '—'
      ),
  },
  {
    // Edit-only action (pencil → edit form). The 'Edit Action' id renders NO
    // delete icon — games have no delete endpoint (disable via Status instead).
    // viewAction also renders a leaderboard icon that jumps straight to
    // /games/leaderboard/:id (see PaginationTable.js 'Edit Action' branch).
    Header: 'Actions',
    id: TableHeaderConstant.EditAction,
    accessor: '',
    viewAction: true,
  },
];

export const tierTableHeader = [
  { Header: TableHeaderConstant.Name, accessor: TableHeaderConstant.NameKey },

  {
    Header: TableHeaderConstant.Parent,
    accessor: TableHeaderConstant.ParentKey,
  },
  {
    Header: TableHeaderConstant.MallName,
    accessor: TableHeaderConstant.MallNameKey,
  },
  {
    Header: TableHeaderConstant.Priority,
    accessor: TableHeaderConstant.PriorityKey,
  },
  {
    Header: TableHeaderConstant.Range,
    accessor: TableHeaderConstant.RangeKey,
  },
  {
    Header: TableHeaderConstant.StartDate,
    accessor: TableHeaderConstant.StartDateKey,
  },
  {
    Header: TableHeaderConstant.EndDate,
    accessor: TableHeaderConstant.EndDateKey,
  },

  { Header: TableHeaderConstant.Status, accessor: '' },
  { Header: TableHeaderConstant.Action, accessor: '' },
];

export const voucherTableHeader = [
  {
    Header: TableHeaderConstant.Title,
    accessor: TableHeaderConstant.VoucherTitleKey,
  },
  {
    Header: TableHeaderConstant.MallName,
    accessor: TableHeaderConstant.MallNameKey,
  },

  {
    Header: TableHeaderConstant.StoreName,
    accessor: TableHeaderConstant.StoreNameKey,
  },
 
  {
    Header: TableHeaderConstant.LoyaltyPoints,
    accessor: TableHeaderConstant.LoyaltyPointsKey,
  },
  {
    Header: TableHeaderConstant.TotalAvailableVouchers,
    accessor: TableHeaderConstant.TotalAvailableVouchersKey,
  },

  {
    Header: TableHeaderConstant.RemainingVouchers,
    accessor: TableHeaderConstant.RemainingVouchersKey,
  },
  {
    Header: TableHeaderConstant.VoucherReservedCount,
    accessor: TableHeaderConstant.VoucherReservedCountKey,
  },
  {
    Header: TableHeaderConstant.VoucherClaimedCount,
    accessor: TableHeaderConstant.VoucherClaimedCountKey,
  },

  {
    Header: TableHeaderConstant.StartDate,
    accessor: TableHeaderConstant.StartDateKey,
    Cell: ({ value }) => {
      return ParseTableLabelDate(value);
    },
  },
  {
    Header: TableHeaderConstant.ExpiredDate,
    accessor: TableHeaderConstant.ExpiryDateKey,
    Cell: ({ value }) => {
      return ParseTableLabelDate(value);
    },
  },
  {
    Header: 'Bundle',
    accessor: 'packageName',
    Cell: ({ value }) =>
      value ? <span className='bdg voilet'>{value}</span> : '\u2014',
  },
  { Header: TableHeaderConstant.Status, accessor: '' },
  {
    Header: TableHeaderConstant.Action,
    accessor: '',
    complimentaryAction: true,
  },
];

export const cancelVoucherTableHeader = [
  {
    Header: 'All',
    accessor: 'Checkbox',
  },
    {
    Header: TableHeaderConstant.Customername,
    accessor: TableHeaderConstant.CustomernameKey,
  },
  {
    Header: TableHeaderConstant.ContactNumber,
    accessor: TableHeaderConstant.PhoneKey,
  },


  {
    Header: TableHeaderConstant.Title,
    accessor: TableHeaderConstant.VoucherTitleKey,
  },
  {
    Header: TableHeaderConstant.MallName,
    accessor: TableHeaderConstant.MallNameKey,
  },

  {
    Header: TableHeaderConstant.StoreName,
    accessor: TableHeaderConstant.StoreNameKey,
  },

  {
    Header: TableHeaderConstant.LoyaltyPoints,
    accessor: TableHeaderConstant.LoyaltyPointsKey,
  },

  {
    Header: TableHeaderConstant.StartDate,
    accessor: TableHeaderConstant.StartDateKey,
    Cell: ({ value }) => {
      return ParseTableLabelDate(value);
    },
  },
  {
    Header: TableHeaderConstant.ExpiredDate,
    accessor: TableHeaderConstant.ExpiryDateKey,
    Cell: ({ value }) => {
      return ParseTableLabelDate(value);
    },
  },
  {
    Header: TableHeaderConstant.VoucherReserveDate,
    accessor: TableHeaderConstant.VoucherReserveDateKey,
    Cell: ({ value }) => {
      return ParseTableDate(value);
    },
  },
  {
    Header: TableHeaderConstant.VoucherStatus,
    accessor: TableHeaderConstant.VoucherStatusKey,
  },
];
export const offerTableHeader = [
  {
    Header: TableHeaderConstant.Title,
    accessor: TableHeaderConstant.TitleKey,
  },
  {
    Header: TableHeaderConstant.MallName,
    accessor: TableHeaderConstant.MallNameKey,
  },

  {
    Header: TableHeaderConstant.StoreName,
    accessor: TableHeaderConstant.StoreNameKey,
  },
  {
    Header: TableHeaderConstant.StartDate,
    accessor: TableHeaderConstant.StartDateKey,
  },
  {
    Header: TableHeaderConstant.EndDate,
    accessor: TableHeaderConstant.EndDateKey,
  },

  { Header: TableHeaderConstant.Status, accessor: '' },
  { Header: TableHeaderConstant.Action, accessor: '' },
];
export const billValidationHeader = [
  {
    Header: TableHeaderConstant.MallName,
    accessor: TableHeaderConstant.MallNameKey,
  },
  {
    Header: TableHeaderConstant.ContactNumber,
    accessor: TableHeaderConstant.ContactNumberKey3,
  },
  {
    Header: TableHeaderConstant.BillDate,
    accessor: TableHeaderConstant.BillDateKey,
    Cell: ({ value }) => {
      return ParseTableLabelDate(value);
    },
  },
  {
    Header: TableHeaderConstant.BillNumber,
    accessor: TableHeaderConstant.BillNumberKey,
  },
  {
    Header: TableHeaderConstant.BillAmount,
    accessor: TableHeaderConstant.BillAmountKey,
    Cell: ({ value }) => {
      return formatToIndianRupee(value);
    },
  },
  {
    Header: TableHeaderConstant.CategoryName,
    accessor: TableHeaderConstant.CategoryNameKey,
  },
  {
    Header: TableHeaderConstant.StoreName,
    accessor: TableHeaderConstant.StoreNameKey,
  },
  {
    Header: TableHeaderConstant.BillStatus,
    accessor: TableHeaderConstant.BillStatusKey,
  },
  {
    Header: TableHeaderConstant.ViewDetails,
    accessor: TableHeaderConstant.ViewDetailsKey,
  },
];

export const CustomerManagementHeader = [
  {
    Header: TableHeaderConstant.ContactNumber,
    accessor: TableHeaderConstant.PhoneKey,
  },
  {
    Header: TableHeaderConstant.Name,
    accessor: TableHeaderConstant.NameKey,
  },
  {
    Header: TableHeaderConstant.Email,
    accessor: TableHeaderConstant.EmailKey,
  },
  {
    Header: TableHeaderConstant.ParentMall,
    accessor: TableHeaderConstant.MallNameKey,
  },
  {
    Header: TableHeaderConstant.RegistrationDate,
    accessor: TableHeaderConstant.RegistrationDateKey,
    Cell: ({ value }) => {
      return ParseTableDate(value);
    },
  },
  {
    Header: TableHeaderConstant.LastActiveAt,
    accessor: TableHeaderConstant.LastActiveAtKey,
    Cell: ({ value }) => {
      return ParseTableDate(value);
    },
  },
  {
    Header: TableHeaderConstant.ReserveVoucher,
    accessor: TableHeaderConstant.ReserveVoucherKey,
  },
  {
    Header: TableHeaderConstant.CollectedVoucher,
    accessor: TableHeaderConstant.CollectedVoucherKey,
  },
  {
    Header: TableHeaderConstant.TotalPoints,
    accessor: TableHeaderConstant.TotalPointsKey,
    Cell: ({ value }) => {
      return value ? value + ' Points' : '';
    },
  },
  {
    Header: TableHeaderConstant.TotalShoppingAmount,
    accessor: TableHeaderConstant.TotalShoppingAmountKey,
    Cell: ({ value }) => {
      return formatToIndianRupee(value);
    },
  },
  {
    // Total approved spend in the last 12 months (all malls) — the rolling
    // window the tier engine uses.
    Header: TableHeaderConstant.Last12MonthSpend,
    accessor: TableHeaderConstant.Last12MonthSpendKey,
    Cell: ({ value }) => {
      return formatToIndianRupee(value);
    },
  },
  {
    // Expiry cut-off shown once in the header (last day of the current month)
    // instead of repeated on every row, e.g. "Expiring Points · by 31 Jul 2026".
    Header: () => {
      const expiryLabel = new Date(
        new Date().getFullYear(),
        new Date().getMonth() + 1,
        0
      ).toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
      });
      return `${TableHeaderConstant.ExpiringPoints} · by ${expiryLabel}`;
    },
    accessor: TableHeaderConstant.ExpiringPointsKey,
    Cell: ({ value }) => {
      if (value === null || value === undefined || value === '') return '';
      const num = Number(value);
      if (isNaN(num)) return value;
      return `${num <= 0 ? 0 : value} Points`;
    },
  },
  {
    Header: TableHeaderConstant.CumulativeUsablePoints,
    accessor: TableHeaderConstant.CumulativeUsablePointsKey,
    Cell: ({ value }) => {
      return value || value === 0
        ? Number(value).toLocaleString('en-IN') + ' Points'
        : '';
    },
  },
  {
    Header: TableHeaderConstant.UsedPoints,
    accessor: TableHeaderConstant.UsedPointsKey,
    Cell: ({ value }) => {
      return value ? value + ' Points' : '';
    },
  },
  {
    Header: TableHeaderConstant.PrivilegeTaken,
    accessor: TableHeaderConstant.PrivilegeTakenKey,
  },

  {
    Header: 'Tier (based on parent mall)',
    id: TableHeaderConstant.TierName,
    accessor: TableHeaderConstant.TierNameKey,
  },
  {
    Header: TableHeaderConstant.CustomerStatus,
    accessor: TableHeaderConstant.CustomerStatusKey,
  },
  {
    Header: TableHeaderConstant.IsDeletedStatus,
    accessor: TableHeaderConstant.IsdeletedStatusKey,
  },
  {
    Header: TableHeaderConstant.ViewDetails,
    accessor: TableHeaderConstant.ViewDetailsKey,
  },
];

export const CustomerBillHistoryHeader = [
  {
    Header: TableHeaderConstant.BillDate,
    accessor: TableHeaderConstant.BillDateKey,
    Cell: ({ value }) => {
      return ParseTableLabelDate(value);
    },
  },
  {
    Header: TableHeaderConstant.BillUploadDate,
    accessor: TableHeaderConstant.BillUploadDateKey,
    Cell: ({ value }) => {
      return ParseTableDate(value);
    },
  },
  {
    Header: TableHeaderConstant.ParentMall,
    accessor: TableHeaderConstant.ParentMallKey,
  },
  {
    Header: TableHeaderConstant.Approver,
    accessor: TableHeaderConstant.ApproverKey,
  },
  {
    Header: TableHeaderConstant.MallName,
    accessor: TableHeaderConstant.MallNameKey,
  },
  {
    Header: TableHeaderConstant.StoreName,
    accessor: TableHeaderConstant.StoreNameKey,
  },
  {
    Header: TableHeaderConstant.CustomerBillAmount,
    accessor: TableHeaderConstant.CustomerBillAmountKey,
    Cell: ({ value }) => {
      return formatToIndianRupee(value);
    },
  },
  {
    Header: TableHeaderConstant.NewPointsAdded,
    accessor: TableHeaderConstant.NewPointsAddedKey,
    Cell: ({ value }) => {
      return value ? value + ' Points' : '';
    },
  },
  {
    Header: TableHeaderConstant.BillStatus,
    accessor: TableHeaderConstant.BillStatusKey,
  },
];

export const CustomerVouchersHeader = [
  {
    Header: TableHeaderConstant.Title,
    accessor: TableHeaderConstant.TitleKey,
  },
  {
    Header: TableHeaderConstant.Complimentary,
    accessor: TableHeaderConstant.ComplimentaryKey,
    // Required: the raw value is a boolean, and React renders a bare
    // `false` as nothing at all — without this Cell, every points-paid
    // voucher (the majority case) would show a blank cell instead of "No".
    Cell: ({ value }) => {
      return value ? 'Yes' : 'No';
    },
  },
  {
    Header: TableHeaderConstant.MallName,
    accessor: TableHeaderConstant.MallNameKey,
  },
  {
    Header: TableHeaderConstant.StoreName,
    accessor: TableHeaderConstant.StoreNameKey,
  },
  {
    Header: TableHeaderConstant.ReservedDate,
    accessor: TableHeaderConstant.CreatedAtKey,
    Cell: ({ value }) => {
      return ParseTableDate(value);
    },
  },
  {
    Header: TableHeaderConstant.CancelDate,
    accessor: TableHeaderConstant.UpdatedAtKey,
    Cell: ({ value }) => {
      return ParseTableDate(value);
    },
  },
  {
    Header: TableHeaderConstant.VoucherStatus,
    accessor: TableHeaderConstant.VoucherStatusKey,
  },
  // {
  //   Header: TableHeaderConstant.ReserveVoucherHeader,
  //   accessor: '',
  // },
  {
    Header: TableHeaderConstant.CancelVoucherHeader,
    accessor: '',
  },
  {
    Header: 'Action',
    id: TableHeaderConstant.CollectVoucher,
    accessor: TableHeaderConstant.CollectVoucherKey,
  },
];

export const CustomerMallWiseTierHeader = [
  {
    Header: TableHeaderConstant.MallName,
    accessor: TableHeaderConstant.MallNameKey,
  },
  {
    Header: TableHeaderConstant.ShoppingAmount,
    accessor: TableHeaderConstant.ShoppingAmountKey,
    Cell: ({ value }) => {
      return formatToIndianRupee(value);
    },
  },
  {
    // The migrated spend the Shopping Amount column excludes, per mall.
    Header: TableHeaderConstant.MigratedShopping,
    accessor: TableHeaderConstant.MigratedShoppingKey,
    Cell: ({ value }) => {
      return formatToIndianRupee(value);
    },
  },
  {
    // Rolling 12-month spend — for Accrual this shows progress toward the
    // threshold; for held tiers it can sit below it (decaying), which the
    // Earned With / Downgrade Due columns then explain.
    Header: TableHeaderConstant.QualifyingSpend,
    accessor: TableHeaderConstant.QualifyingSpendKey,
    Cell: ({ value }) => {
      return formatToIndianRupee(value);
    },
  },
  {
    // The qualifying spend (incl. migrated) that actually EARNED the current tier —
    // measured in the 12-month window ending at the upgrade date. Unlike the live
    // "Past 12-Month Spend" (which decays as the window rolls and migrated bills age
    // out), this reconciles amount -> tier for every account, migrated or not.
    Header: TableHeaderConstant.TierEarnedBy,
    accessor: TableHeaderConstant.TierEarnedByKey,
    Cell: ({ value }) => {
      // No qualifying amount (Accrual / never upgraded) → show a dash, not ₹0.00
      if (!value || Number(value) === 0) return '-';
      return formatToIndianRupee(value);
    },
  },
  {
    // Date the customer was upgraded to the current tier.
    Header: TableHeaderConstant.UpgradedOn,
    accessor: TableHeaderConstant.UpgradedOnKey,
    Cell: ({ value }) => {
      return value
        ? new Date(value).toLocaleDateString('en-GB', {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
          })
        : '—';
    },
  },
  {
    // Downgrade date = the tier's stored endedAt — the exact date the downgrade cron
    // re-evaluates the tier (its filter is `endedAt < today`). Shown as-is; endedAt
    // already includes the grace period, so we no longer add grace again on top.
    Header: TableHeaderConstant.DowngradeDue,
    accessor: TableHeaderConstant.DowngradeDueKey,
    Cell: ({ value }) => {
      return value
        ? new Date(value).toLocaleDateString('en-GB', {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
          })
        : '—';
    },
  },
  {
    Header: TableHeaderConstant.PointsAdded,
    accessor: TableHeaderConstant.PointsAddedKey,
    Cell: ({ value }) => {
      return value ? value + ' Points' : '';
    },
  },
  {
    Header: TableHeaderConstant.TierName,
    accessor: TableHeaderConstant.TierNameKey,
  },
];

export const reportOverALlDataHeader = [
  {
    Header: TableHeaderConstant.Name,
    accessor: TableHeaderConstant.NameKey,
  },
  {
    Header: TableHeaderConstant.ContactNumber,
    accessor: TableHeaderConstant.PhoneKey,
  },
  {
    Header: TableHeaderConstant.Email,
    accessor: TableHeaderConstant.EmailKey,
  },
  {
    Header: TableHeaderConstant.Gender,
    accessor: TableHeaderConstant.GenderKey,
  },
  {
    Header: TableHeaderConstant.MallName,
    accessor: TableHeaderConstant.MallNameKey,
  },
  {
    Header: TableHeaderConstant.ParentMall,
    accessor: TableHeaderConstant.parentMallKey2,
  },
  {
    Header: TableHeaderConstant.TotalPoints,
    accessor: TableHeaderConstant.TotalPointsKey,
    Cell: ({ value }) => {
      return value ? value + ' Points' : '';
    },
  },
  {
    Header: TableHeaderConstant.MembershipType,
    accessor: TableHeaderConstant.MembershipTypeKey,
  },

  {
    Header: TableHeaderConstant.BillDate,
    accessor: TableHeaderConstant.BillDateKey,
    Cell: ({ value }) => {
      return ParseTableLabelDate(value);
    },
  },
  {
    Header: TableHeaderConstant.Upload_date,
    accessor: TableHeaderConstant.upload_dateKey,
    Cell: ({ value }) => {
      return ParseTableDate(value);
    },
  },

  {
    Header: TableHeaderConstant.BillAmount,
    accessor: TableHeaderConstant.BillAmountKey,
    Cell: ({ value }) => {
      return formatToIndianRupee(value);
    },
  },
  {
    Header: TableHeaderConstant.MallWiseBillTotal,
    accessor: TableHeaderConstant.MallWiseBillTotalKey,
  },
  {
    Header: TableHeaderConstant.EachBillRewards,
    accessor: TableHeaderConstant.EachBillRewardsKey,
  },

  {
    Header: TableHeaderConstant.StoreName,
    accessor: TableHeaderConstant.StoreNameKey,
  },

  {
    Header: TableHeaderConstant.Address,
    accessor: TableHeaderConstant.AddressKey,
  },

  {
    Header: TableHeaderConstant.Approver,
    accessor: TableHeaderConstant.ApproverKey,
  },
  {
    Header: TableHeaderConstant.FirstBillDate,
    accessor: TableHeaderConstant.firstBillDateKey,
    Cell: ({ value }) => {
      return ParseTableDate(value);
    },
  },
];

export const reportnewUserDataHeader = [
  {
    Header: TableHeaderConstant.Name,
    accessor: TableHeaderConstant.NameKey,
  },
  {
    Header: TableHeaderConstant.ContactNumber,
    accessor: TableHeaderConstant.PhoneKey,
  },
  {
    Header: TableHeaderConstant.Dob,
    accessor: TableHeaderConstant.DobKey,
    Cell: ({ value }) => {
      return ParseTableLabelDate(value);
    },
  },

  {
    Header: TableHeaderConstant.Anniversary,
    accessor: TableHeaderConstant.AnniversaryKey,
    Cell: ({ value }) => {
      return ParseTableLabelDate(value);
    },
  },
  {
    Header: TableHeaderConstant.Address,
    accessor: TableHeaderConstant.AddressKey,
  },
  {
    Header: TableHeaderConstant.DateOfDownload,
    accessor: TableHeaderConstant.DateOfDownloadKey,
    Cell: ({ value }) => {
      return ParseTableDate(value);
    },
  },

  {
    Header: TableHeaderConstant.LastLogin,
    accessor: TableHeaderConstant.LastLoginKey,
    Cell: ({ value }) => {
      return ParseTableDate(value);
    },
  },

  {
    Header: TableHeaderConstant.RegistrationDate,
    accessor: TableHeaderConstant.RegistrationDateKey,
    Cell: ({ value }) => {
      return ParseTableDate(value);
    },
  },
  {
    Header: TableHeaderConstant.FirstBillDate,
    accessor: TableHeaderConstant.firstBillDateKey,
    Cell: ({ value }) => {
      return ParseTableDate(value);
    },
  },
  {
    Header: TableHeaderConstant.ReferrerContact,
    accessor: TableHeaderConstant.ReferrerContactKey,
  },
  {
    Header: TableHeaderConstant.ReferrerName,
    accessor: TableHeaderConstant.ReferrerNameKey,
  },
];

export const reportOverALlPointsDataHeader = [
  {
    Header: TableHeaderConstant.Name,
    accessor: TableHeaderConstant.NameKey,
  },
  {
    Header: TableHeaderConstant.ContactNumber,
    accessor: TableHeaderConstant.PhoneKey,
  },
  {
    Header: TableHeaderConstant.MallName,
    accessor: TableHeaderConstant.MallNameKey,
  },
  {
    Header: TableHeaderConstant.ParentMall,
    accessor: TableHeaderConstant.ParentMallKey,
  },
  {
    Header: TableHeaderConstant.FirstBillDate,
    accessor: TableHeaderConstant.firstBillDateKey,
    Cell: ({ value }) => {
      return ParseTableDate(value);
    },
  },
  {
    Header: TableHeaderConstant.TotalAcceptedBills,
    accessor: TableHeaderConstant.TotalAcceptedBillsKey,
  },
  {
    Header: TableHeaderConstant.MembershipType,
    accessor: TableHeaderConstant.MembershipTypeKey,
  },

  {
    Header: TableHeaderConstant.ParentMallPoints,
    accessor: TableHeaderConstant.ParentMallPointsKey,
  },
  {
    Header: TableHeaderConstant.TotalExpiredPoints,
    accessor: TableHeaderConstant.TotalExpiredPointsKey,
  },
  {
    Header: TableHeaderConstant.TotalPointsLeft,
    accessor: TableHeaderConstant.TotalPointsLeftKey,
  },
  {
    Header: TableHeaderConstant.TotalUsedPoints,
    accessor: TableHeaderConstant.TotalUsedPointsKey,
  },
  {
    Header: TableHeaderConstant.TotalPoints,
    accessor: TableHeaderConstant.TotalPointsKey,
  },
];
export const reportvoucherPointsDataHeader = [
  {
    Header: TableHeaderConstant.VoucherSerialNumber,
    accessor: TableHeaderConstant.VoucherSerialNumberKey,
  },
  {
    Header: TableHeaderConstant.VoucherIssuedBy,
    accessor: TableHeaderConstant.VoucherIssuedByKey,
  },
  {
    Header: TableHeaderConstant.Name,
    accessor: TableHeaderConstant.NameKey,
  },
  {
    Header: TableHeaderConstant.ContactNumber,
    accessor: TableHeaderConstant.PhoneKey,
  },
  {
    Header: TableHeaderConstant.MallName,
    accessor: TableHeaderConstant.MallNameKey,
  },
  {
    Header: TableHeaderConstant.ParentMall,
    accessor: TableHeaderConstant.ParentMallKey,
  },
  {
    Header: TableHeaderConstant.Denomination,
    accessor: TableHeaderConstant.LoyaltyPointsKey,
  },
  {
    Header: TableHeaderConstant.VoucherTitle, // <-- Added Voucher Title after Voucher Serial Number
    accessor: TableHeaderConstant.VoucherTitleKey,
  },
  {
    // Exclusive = special voucher, Bundle = voucher inside a bundle,
    // Regular = everything else (game vouchers included). Set by the server.
    Header: 'Voucher Type',
    accessor: 'voucherType',
  },
  {
    Header: TableHeaderConstant.ComplementaryVoucher,
    accessor: TableHeaderConstant.ComplementaryVoucherKey,
  },
  {
  Header: TableHeaderConstant.ComplementaryVoucherDenomination,
  accessor: TableHeaderConstant.ComplementaryVoucherDenominationKey,
  },
  {
    Header: TableHeaderConstant.GamePlayed,
    accessor: TableHeaderConstant.GamePlayedKey,
  },
  {
    Header: TableHeaderConstant.GameBillStartDate,
    accessor: TableHeaderConstant.GameBillStartDateKey,
    Cell: ({ value }) => {
      return ParseTableLabelDate(value);
    },
  },
  {
    Header: TableHeaderConstant.GameBillEndDate,
    accessor: TableHeaderConstant.GameBillEndDateKey,
    Cell: ({ value }) => {
      return ParseTableLabelDate(value);
    },
  },

  {
    Header: TableHeaderConstant.StoreName,
    accessor: TableHeaderConstant.BrandNameKey2,
  },

  {
    Header: TableHeaderConstant.FirstBillDate,
    accessor: TableHeaderConstant.firstBillDateKey,
    Cell: ({ value }) => {
      return ParseTableDate(value);
    },
  },
  {
    Header: TableHeaderConstant.TotalAcceptedBills,
    accessor: TableHeaderConstant.TotalAcceptedBillsKey,
  },
  {
    Header: TableHeaderConstant.MembershipType,
    accessor: TableHeaderConstant.MembershipTypeKey,
  },

  {
    Header: TableHeaderConstant.ParentMallPoints,
    accessor: TableHeaderConstant.ParentMallPointsKey,
  },
  {
    Header: TableHeaderConstant.TotalExpiredPoints,
    accessor: TableHeaderConstant.TotalExpiredPointsKey,
  },
  {
    Header: TableHeaderConstant.TotalPointsLeft,
    accessor: TableHeaderConstant.TotalPointsLeftKey,
  },
  {
    Header: TableHeaderConstant.TotalUsedPoints,
    accessor: TableHeaderConstant.TotalUsedPointsKey,
  },
  {
    Header: TableHeaderConstant.TotalPoints,
    accessor: TableHeaderConstant.TotalPointsKey,
  },
  {
    Header: TableHeaderConstant.VoucherCollectedDate,
    accessor: TableHeaderConstant.VoucherCollectionDateKey,
    Cell: ({ value }) => {
      return ParseTableDate(value);
    },
  },
  {
    Header: TableHeaderConstant.VoucherReserveDate,
    accessor: TableHeaderConstant.VoucherReserveDateKey,
    Cell: ({ value }) => {
      return ParseTableDate(value);
    },
  },
];

export const CustomerPrivilegeHeader = [
  {
    Header: TableHeaderConstant.Title,
    accessor: TableHeaderConstant.TitleKey,
  },
  {
    Header: TableHeaderConstant.PrivilegeBenefits,
    accessor: TableHeaderConstant.PrivilegeBenefitsKey,
  },
  {
    Header: TableHeaderConstant.PrivilegeDates,
    accessor: TableHeaderConstant.PrivilegeDatesKey,
  },
  {
    Header: TableHeaderConstant.PrivilegeUsed,
    accessor: TableHeaderConstant.PrivilegeUsedKey,
  },
  {
    Header: TableHeaderConstant.PrivilegeCount,
    accessor: TableHeaderConstant.PrivilegeCountKey,
  },
  {
    Header: 'Action',
    accessor: TableHeaderConstant.CollectPrivilegeKey,
    id: TableHeaderConstant.CollectPrivilege,
  },
];

export const CustomerLedgerHeader = [
  {
    Header: TableHeaderConstant.MallName,
    accessor: TableHeaderConstant.MallNameKey,
    Cell: ({ value }) => value || '-',
  },
  {
    Header: TableHeaderConstant.StoreName,
    accessor: TableHeaderConstant.StoreNameKey,
    Cell: ({ value }) => value || '-',
  },
  {
    Header: TableHeaderConstant.Source,
    accessor: TableHeaderConstant.SourceKey,
  },
  {
    Header: TableHeaderConstant.Balance,
    accessor: TableHeaderConstant.BalanceKey,
    Cell: ({ value }) => {
      return formatToIndianRupee(value);
    },
  },
  {
    Header: TableHeaderConstant.Coins,
    accessor: TableHeaderConstant.CoinsKey,
  },
  {
    Header: TableHeaderConstant.LedgerType,
    accessor: TableHeaderConstant.LedgerTypekey,
  },
  {
    Header: TableHeaderConstant.ExpiryDate,
    accessor: TableHeaderConstant.ExpiryDateKey,
    Cell: ({ value }) => {
      return ParseTableLabelDate(value);
    },
  },
];

export const notificationTableHeader = [
  {
    Header: TableHeaderConstant.Name,
    accessor: TableHeaderConstant.NameKey,
  },
  {
    Header: TableHeaderConstant.MallName,
    accessor: TableHeaderConstant.MallNameKey,
  },
  {
    Header: TableHeaderConstant.Tier_Name,
    accessor: TableHeaderConstant.TierNameKey,
  },
  {
    Header: TableHeaderConstant.Date_Time,
    accessor: TableHeaderConstant.Date_TimeKey,
  },
  {
    Header: TableHeaderConstant.Title,
    accessor: TableHeaderConstant.TitleKey,
  },
  {
    Header: TableHeaderConstant.Gender,
    accessor: TableHeaderConstant.GenderKey,
  },
];

export const FeedbackHeader = [
  {
    Header: 'Feedback Name',
    id: TableHeaderConstant.Title,
    accessor: TableHeaderConstant.TitleKey,
  },
  {
    Header: TableHeaderConstant.Headline,
    accessor: TableHeaderConstant.HeadlineKey,
  },
  {
    Header: TableHeaderConstant.Description,
    accessor: TableHeaderConstant.DescriptionKey,
  },
  {
    Header: TableHeaderConstant.StartDate,
    accessor: TableHeaderConstant.StartDateKey,
    Cell: ({ value }) => {
      return ParseTableLabelDate(value);
    },
  },
  {
    Header: TableHeaderConstant.ExpiredDate,
    accessor: TableHeaderConstant.ExpiredDateKey,
    Cell: ({ value }) => {
      return ParseTableLabelDate(value);
    },
  },

  {
    Header: TableHeaderConstant.DaysVisibleOnHomeScreen,
    accessor: TableHeaderConstant.DaysVisibleOnHomeScreenKey,
  },
  { Header: TableHeaderConstant.Status, accessor: '' },

  {
    Header: 'Actions',
    id: TableHeaderConstant.EditAction,
    accessor: '',
  },
];

export const reportLiabilityHeader = [
  {
    Header: TableHeaderConstant.MallName,
    accessor: TableHeaderConstant.MallNameKey,
  },
  {
    Header: TableHeaderConstant.TotalMember,
    accessor: TableHeaderConstant.TotalMemberKey,
  },
  {
    Header: TableHeaderConstant.UsablePoints,
    accessor: TableHeaderConstant.UsablePointsKey,
    isHover: true,
  },
  {
    Header: TableHeaderConstant.TotalExpiredPoints,
    accessor: TableHeaderConstant.TotalExpiredPointsKey,
    isHover: true,
  },

  {
    Header: TableHeaderConstant.VoucherCustomerCount,
    accessor: TableHeaderConstant.VoucherCustomerCountKey,
    isHover: true,
  },
  {
    Header: TableHeaderConstant.VoucherCollectedPoints,
    accessor: TableHeaderConstant.VoucherCollectedPointsKey,
    isHover: true,
  },

  {
    Header: TableHeaderConstant.TotalCustomerBillCount,
    accessor: TableHeaderConstant.TotalCustomerBillCountKey,
    isHover: true,
  },
  {
    Header: TableHeaderConstant.TotalBillCoins,
    accessor: TableHeaderConstant.TotalBillCoinsKey,
    isHover: true,
  },
  {
    Header: TableHeaderConstant.InactiveCustomerCount,
    accessor: TableHeaderConstant.InactiveCustomerCountKey,
    isHover: true,
  },
  {
    Header: TableHeaderConstant.ActiveMemberPercentage,
    accessor: TableHeaderConstant.ActiveMemberPercentageKey,
  },
  {
    Header: TableHeaderConstant.NonActiveMemberPercentage,
    accessor: TableHeaderConstant.NonActiveMemberPercentageKey,
  },
];

export const reportRedemptionHeader = [
  {
    Header: TableHeaderConstant.BrandVoucherListed,
    accessor: TableHeaderConstant.BrandVoucherListedKey,
  },
  {
    Header: TableHeaderConstant.BrandVoucherListedDenomination,
    accessor: TableHeaderConstant.BrandVoucherListedDenominationKey,
  },
  {
    Header: TableHeaderConstant.ListedVoucherTotal,
    accessor: TableHeaderConstant.ListedVoucherTotalKey,
  },
  {
    Header: TableHeaderConstant.IssuedQuantity,
    accessor: TableHeaderConstant.IssuedQuantityKey,
  },
  {
    Header: TableHeaderConstant.IssuedVouchersValue,
    accessor: TableHeaderConstant.IssuedVouchersValueKey,
  },
  {
    Header: TableHeaderConstant.PendingVoucher,
    accessor: TableHeaderConstant.PendingVoucherKey,
  },
  {
    Header: TableHeaderConstant.VoucherQtyReceivedByBrand,
    accessor: TableHeaderConstant.voucherQtyReceivedByBrandKey,
    type: TableHeaderConstant.InputAction,
    inputType: 'number',
  },
  {
    Header: TableHeaderConstant.Consumption,
    accessor: TableHeaderConstant.ConsumptionKey,
    type: TableHeaderConstant.InputAction,
    inputType: 'number',
  },
  {
    Header: TableHeaderConstant.GVAmtReceivedByBrand,
    accessor: TableHeaderConstant.GVAmtReceivedByBrandKey,
    type: TableHeaderConstant.Calculate,
  },
  {
    Header: TableHeaderConstant.IncrementAmount,
    accessor: TableHeaderConstant.IncrementAmountKey,
    type: TableHeaderConstant.Calculate,
  },
  {
    Header: TableHeaderConstant.IncrementPercent,
    accessor: TableHeaderConstant.IncrementPercentKey,
    type: TableHeaderConstant.Calculate,
  },
  {
    Header: TableHeaderConstant.Remarks,
    accessor: TableHeaderConstant.RemarksKey,
    type: TableHeaderConstant.InputAction,
  },
];

export const slabBifurcationHeader = [
  {
    Header: TableHeaderConstant.MallName,
    accessor: TableHeaderConstant.MallNameKey,
  },
  {
    Header: TableHeaderConstant.AccrualCount,
    accessor: TableHeaderConstant.AccrualCountKey,
  },
  {
    Header: TableHeaderConstant.AccrualAmount,
    accessor: TableHeaderConstant.AccrualAmountKey,
  },
  {
    Header: TableHeaderConstant.EnthusiastCount,
    accessor: TableHeaderConstant.EnthusiastCountKey,
  },
  {
    Header: TableHeaderConstant.EnthusiastAmount,
    accessor: TableHeaderConstant.EnthusiastAmountKey,
  },
  {
    Header: TableHeaderConstant.InsiderCount,
    accessor: TableHeaderConstant.InsiderCountKey,
  },
  {
    Header: TableHeaderConstant.InsiderAmount,
    accessor: TableHeaderConstant.InsiderAmountKey,
  },
  {
    Header: TableHeaderConstant.InfluencerCount,
    accessor: TableHeaderConstant.InfluencerCountKey,
  },
  {
    Header: TableHeaderConstant.InfluencerAmount,
    accessor: TableHeaderConstant.InfluencerAmountKey,
  },
];

export const campaignTableHeader = [
  // Campaign ID column intentionally omitted — internal identifier, not shown
  // to the admin. The campaign name is the human identifier instead; edit/view
  // still use the row's id under the hood.
  {
    Header: 'Campaign Name',
    accessor: 'name',
    Cell: ({ value, row }) => value || `Campaign #${row?.original?.id ?? ''}`,
  },
  {
    Header: 'Game Type',
    accessor: 'gameType',
    Cell: ({ value }) => GAME_TYPE_LABELS[value] || value,
  },
  {
    Header: 'Trigger Type',
    accessor: 'triggerType',
    Cell: ({ value }) => TRIGGER_TYPE_LABELS[value] || value,
  },
  // The BILL window, not the campaign window. Which invoice dates count is
  // what an admin scans this list for; the campaign window is only game
  // availability and is now optional (Phase 9), so it is frequently blank and
  // made a poor column. Both are nullable — ParseTableDate returns its input
  // unchanged when falsy, so fall back to a dash rather than an empty cell.
  // Both are nullable — a campaign only needs a bill window when it reads
  // bills. An empty cell is left genuinely empty (no placeholder dash), which
  // ParseTableDate already does by returning its input unchanged when falsy.
  {
    Header: 'Bill Start Date',
    accessor: 'billStartDate',
    Cell: ({ value }) => ParseTableLabelDate(value),
  },
  {
    Header: 'Bill End Date',
    accessor: 'billEndDate',
    Cell: ({ value }) => ParseTableLabelDate(value),
  },
  { Header: 'Campaign Status', accessor: '' },
  { Header: 'View Action', accessor: '' },
];
